import {
  convertDateToApiFormat,
  LoyaltyProductGroupBody,
  EditLoyaltyProductGroup,
  LoyaltyProductWCategiriesAdd,
  LoyaltyProductWCategiriesEdit,
} from '@src/api';
import { ALL_CITIES } from '@src/app/modules/search-cities';

import { LoyaltyProgramProductInput } from '../../models';
import { QrCodeImageIndexId } from '../types';

interface ConvertFromProductInputProps {
  product: LoyaltyProgramProductInput;
  imagesIds: string[];
  coverImageId?: string;
  qrCodeImages: QrCodeImageIndexId;
}

// TODO: объединить convertFromProductInputAdd и convertFromProductInputEdit как это было раньше. Скорее всего проблема в этих полях - discountGroups.productId и discountGroups.id
export const convertFromProductInputAdd = ({
  product,
  imagesIds,
  coverImageId,
  qrCodeImages,
}: ConvertFromProductInputProps): LoyaltyProductWCategiriesAdd => {
  const { company, persons } = product.contacts;

  return {
    name: product.name,
    description: product.description,
    descriptionShort: product.descriptionShort,
    discountText: product.discountText,
    dateExpiration: convertDateToApiFormat(product.dateExpiration, false),
    sortOrder: product.sortOrder,
    organisationId: company.id,
    organisationInfo: company.info,
    categoryIds: product.categories.map(item => item.id),
    cities: !!product.cities?.find(item => item.cityId === ALL_CITIES.cityId) ? [] : product.cities,
    discountGroups: product.terms.map<LoyaltyProductGroupBody>((term, index) => ({
      id: term.id ?? '',
      discountRate: term.discountType === 'rate' ? Number(term.discount) : undefined,
      discountAbsolute: term.discountType === 'cash' ? Number(term.discount) : undefined,
      discountText: term.discountType === 'tag' ? term.discount.toString() : undefined,
      discountOptions: term.description,
      discountCode: term.promoCode || undefined,
      isGenerateBarcode: term.showAsBarcode ?? false,
      generateQRCode: term.showAsQRCode ?? false,
      discountQRCodeFileId: qrCodeImages?.[index],
      groupName: term.groupName,
      isPermanentCode: term.isPermanentCode,
      isMultipleCodeUse: !term.isSingleCodeUse,
      maxCodeUsePerMonth: term.isSingleCodeUse ? undefined : term.maxCodeUsePerMonth,
      codesFileId: term.uniqueCodes?.id,
    })),
    contacts: persons,
    mapObjects: product.mapObjects,
    photos: imagesIds.map((id, index) => ({ id, sortOrder: index * 10, isCover: id === coverImageId })),
    contactUserId: product.contacts.mentor?.id ?? undefined,
    // @ts-ignore поле не описано в схеме
    contactUserFIO: product.contacts.mentor?.name ?? undefined,
  };
};

export const convertFromProductInputEdit = ({
  product,
  imagesIds,
  coverImageId,
  qrCodeImages,
}: ConvertFromProductInputProps): LoyaltyProductWCategiriesEdit => {
  const { company, persons } = product.contacts;

  return {
    name: product.name,
    description: product.description,
    descriptionShort: product.descriptionShort,
    discountText: product.discountText,
    dateExpiration: convertDateToApiFormat(product.dateExpiration, false),
    sortOrder: product.sortOrder,
    organisationId: company.id,
    organisationInfo: company.info,
    categoryIds: product.categories.map(item => item.id),
    cities: !!product.cities?.find(item => item.cityId === ALL_CITIES.cityId) ? [] : product.cities,
    discountGroups: product.terms.map<EditLoyaltyProductGroup>((term, index) => ({
      id: term.id ?? '',
      productId: '',
      discountRate: term.discountType === 'rate' ? Number(term.discount) : undefined,
      discountAbsolute: term.discountType === 'cash' ? Number(term.discount) : undefined,
      discountText: term.discountType === 'tag' ? term.discount.toString() : undefined,
      discountOptions: term.description,
      discountCode: term.promoCode || undefined,
      isGenerateBarcode: term.showAsBarcode ?? false,
      generateQRCode: term.showAsQRCode ?? false,
      discountQRCodeFileId: qrCodeImages?.[index],
      groupName: term.groupName,
      isPermanentCode: term.isPermanentCode,
      isMultipleCodeUse: !term.isSingleCodeUse,
      maxCodeUsePerMonth: term.isSingleCodeUse ? undefined : term.maxCodeUsePerMonth,
      codesFileId: term.uniqueCodes?.id,
    })),
    contacts: persons,
    mapObjects: product.mapObjects,
    photos: imagesIds.map((id, index) => ({ id, sortOrder: index * 10, isCover: id === coverImageId })),
    contactUserId: product.contacts.mentor?.id ?? undefined,
    // @ts-ignore поле не описано в схеме
    contactUserFIO: product.contacts.mentor?.name ?? undefined,
  };
};
